import noraPic from "@/public/images/artists/nora.png";
import { Artist } from "@/types/types";

export const nora = {
  id: "127",
  name: "Nora",
  image: noraPic,
  description: `Nora's voice blends elements of clarity and raspiness with a touch of twang typical of female country singers. It carries a distinct tonal quality characterized by a balance between brightness and depth. Its dynamic range enables it to handle both delicate ballads and lively, upbeat tracks with equal proficiency, making it suitable for various genres within the country music spectrum.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fnora-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Female",
    tags: {
      primary: ["Country", "Folk", "Rock", "Indie", "Belting", "Gritty"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Low",
        high: "Low",
      },
      specific: {
        low: 54,
        high: 69,
      },
    },
  },
} as const satisfies Artist;
